// Maps Sanity `componentMetalColour` values to the label shown in Wings.
// Only Wirecore variants are surfaced — plain silver/gold render nothing.
const WIRECORE_LABELS = {
  wirecoreSilver: 'Wirecore Silver',
  wirecoreGold: 'Wirecore Gold'
}

/**
 * Resolve the Wirecore label for a Typesense product/variant document.
 * `componentMetalColour` is a flat field on the variant doc; only the
 * wirecore* values surface a label ('Wirecore Silver' / 'Wirecore Gold'),
 * returning null otherwise.
 *
 * @param {Object} variant - catalogue tile `item` or configurator colour `c`
 * @returns {string|null}
 */
export function getWirecoreLabel(variant) {
  return WIRECORE_LABELS[variant?.componentMetalColour] ?? null
}
